import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { AssistantContainerComponent } from "../../assistant-container/assistant-container.component";
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
    selector: 'app-right-sidenav',
    standalone: true,
    templateUrl: './right-sidenav.component.html',
    styleUrl: './right-sidenav.component.scss',
    imports: [CommonModule, MatSidenavModule, AssistantContainerComponent]
})
export class RightSidenavComponent implements OnInit, OnDestroy{

  @ViewChild('rightSidenav') drawer!: MatSidenav;  // Non-null assertion operator

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  
  toggle(): void {
    this.drawer.toggle();
  }
}
